import { ProtalConstant } from '../../constants/AppConstants';
import { IChatStartPayload } from '../models/ChatbotModels';
import { API_ROUTE } from './ApiRoute';
import ApiService from './ApiService';
import ApiServiceBase from './ApiServiceBase';
import { ServerType, ServiceType } from './ServiceType.data';

const serviceType = ServiceType.None;

export class ChatbotService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.dcaBackend);

  public sendQueryUser(payload: IChatStartPayload): Promise<string> | string {
    const { portalName, query } = payload;
    return this.service.post(
      {
        route: [...(portalName === ProtalConstant.DCA ? [API_ROUTE.DCA] : []), API_ROUTE.CHAT],
      },
      { query },
    );
  }
}

const chatbotService = new ChatbotService();
export default chatbotService;
